import { render, staticRenderFns } from "./CandidatesAddExamRequest.vue?vue&type=template&id=53c12859&lang=pug"
import script from "./CandidatesAddExamRequest.vue?vue&type=script&lang=js"
export * from "./CandidatesAddExamRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports